// querty keys
export const QUERY_KEY_VOUCHERS = 'Vouchers'
export const QUERY_KEY_DAF_COMPANY_VEHICLES = 'dafCompanyVehicles'
// mutation keys
export const MUTATION_KEY_POST_SERVICE_JOBS = 'postVehicleServiceJobs'
export const MUTATION_KEY_POST_DMSC_VEHICLE_OPTIONS = 'postDMSCVehicleOptions'
